import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL PRODUCTS SERVICE
export const getAllProductsService = createAsyncThunk(
  "products/getAllProductsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.productsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE PRODUCT SERVICE
export const createProductService = createAsyncThunk(
  "products/createProductService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.productsURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE PRODUCT SERVICE
export const deleteProductService = createAsyncThunk(
  "products/deleteProductService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.productsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE PRODUCT SERVICE
export const updateProductService = createAsyncThunk(
  "products/updateProductService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.productsURL}/${params?.id}`,
        params.formData
     , {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET Product BY ID SERVICE
export const getProductByIdService = createAsyncThunk(
  "products/getProductByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.productsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);


export const discountTimestampRangeService = createAsyncThunk(
  "products/discountTimestampRangeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(URLS.discountTimestampRangeURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const deleteDiscountTimeRangeService = createAsyncThunk(
  "products/deleteDiscountTimeRangeService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.delete(URLS.discountTimestampRangeURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const getDiscountTimestampRangeService = createAsyncThunk(
  "products/getDiscountTimestampRangeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(URLS.discountTimestampRangeURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);